import { jsx } from "react/jsx-runtime";
import { TidalThemeProvider } from "../../styles/index.js";
import { StoredThemesProvider, usePreviewTheme } from "./context/StoredThemes.js";
function ThemePreviewProvider(props) {
  return /* @__PURE__ */ jsx(StoredThemesProvider, { children: /* @__PURE__ */ jsx(InjectIntoTidal, { ...props }) });
}
function InjectIntoTidal(props) {
  const { previewTheme } = usePreviewTheme();
  return /* @__PURE__ */ jsx(TidalThemeProvider, { "data-testid": "tidalThemeProvider", ...props, theme: previewTheme });
}
export {
  ThemePreviewProvider
};
//# sourceMappingURL=ThemePreviewProvider.js.map
